// @flow

import { parse } from 'query-string';
import { getSearch, getLocation } from '../router';
import { fetchData } from '../../helpers';
import { getHasVbmrEnabled } from '../siteSettings';
import {
  SET_VBMR_AVAILABILITY,
  SET_VBMR_LABEL,
} from './constants';

export const setVbmrAvailability = (isAvailable: boolean) => ({
  type: SET_VBMR_AVAILABILITY,
  isAvailable,
});

export const setVbmrLabel = (label: string) => ({
  type: SET_VBMR_LABEL,
  label,
});

/* This action checks if:
 * - The VBMR parameter is passed in the URL and has the value 1
 * - The current website has vbmr enabled in the site settings
 * - There are free VBMR slots available within the current VBMR time,
 * using the check-vbmr endpoint from our API.
 */
export const checkVbmrAvailability = (
  callback?: Function = () => {},
  checkVbmrParameter: boolean = true,
) => async (
  dispatch: Function, getState: Function) => {
  // Check if VBMR parameter is passed in the URL.
  const state = getState();
  const location = getLocation(state);
  const search = getSearch(state) || location.search;
  const params = parse(search);
  if (checkVbmrParameter && (!params.vbmr || params.vbmr !== '1')) {
    dispatch(setVbmrAvailability(false));
    callback();
    return;
  }

  // Check if VBMR is enabled for this current website (site setting).
  if (!getHasVbmrEnabled(state)) {
    dispatch(setVbmrAvailability(false));
    callback();
    return;
  }

  // There are free VBMR slots available within the current VBMR time.
  try {
    const { json: { result, label } = {} } = await fetchData({
      endpoint: '/api/check-vbmr',
    });
    dispatch(setVbmrAvailability(result));
    dispatch(setVbmrLabel(label));
    callback();
  } catch (error) {
    console.error('An error occurred while trying to check Vbmr availability', error);
  }
};
